import { render, staticRenderFns } from "./DojinCollection.vue?vue&type=template&id=0a0930d4&scoped=true&"
import script from "./DojinCollection.vue?vue&type=script&lang=js&"
export * from "./DojinCollection.vue?vue&type=script&lang=js&"
import style0 from "./DojinCollection.vue?vue&type=style&index=0&id=0a0930d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0930d4",
  null
  
)

component.options.__file = "DojinCollection.vue"
export default component.exports